import {  
  HomePageToolkit,  
  HomePageCompanyLogo,  
  HomePageStarredEntities,  
} from '@backstage/plugin-home';  
import { Content, Page } from '@backstage/core-components';  
import { Grid, makeStyles } from '@material-ui/core';  
import React from 'react';  
import { SearchContextProvider } from '@backstage/plugin-search-react';  
import { HomePageSearchBar } from '@backstage/plugin-search';  
import LogoFull from './LogoFull';
import AddIcon from '@material-ui/icons/Add';
import DescriptionIcon from '@material-ui/icons/Description';
import AddBoxIcon from '@material-ui/icons/AddBox';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import PersonIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';
import { AnnouncementsCard } from '@procore-oss/backstage-plugin-announcements';
import { NewAnnouncementBanner } from '@procore-oss/backstage-plugin-announcements';
import TodayIcon from '@material-ui/icons/Today';

const useStyles = makeStyles(theme => ({  
  searchBarInput: {  
    maxWidth: '60vw',  
    margin: 'auto',  
    backgroundColor: theme.palette.background.paper,  
    borderRadius: '50px',  
    boxShadow: theme.shadows[1],  
  },  
  searchBarOutline: {  
    borderStyle: 'none',  
  },  
}));  
  
const useLogoStyles = makeStyles(theme => ({  
  container: {  
    margin: theme.spacing(2, 0),  
  },
  icon: {
    width: 'auto',
    height: 32,
  },
}));  
  
export const HomePage = () => {  
  const classes = useStyles();  
  const { container, icon } = useLogoStyles();  
  
  const tools = [
    {  
      url: '/create',  
      label: 'Create New Component',  
      icon: <AddIcon className={icon} />,
    },
    {  
      url: '/catalog-import',  
      label: 'Register an Existing Component',  
      icon: <DescriptionIcon className={icon} />,
    },
    {  
      url: '/create/actions',  
      label: 'Create/Actions',  
      icon: <AddBoxIcon className={icon} />, 
    },
    {  
      url: '/docs',  
      label: 'Docs',  
      icon: <FindInPageIcon className={icon} />,
    },  
    {  
      url: '/catalog?filters%5Bkind%5D=user',  
      label: 'User Catalog',  
      icon: <PersonIcon className={icon} />,
    },  
    {  
      url: '/catalog?filters%5Bkind%5D=group',  
      label: 'Group Catalog',  
      icon: <GroupIcon className={icon} />,
    },
    {  
      url: '/reservation',  
      label: 'Reservation',  
      icon: <TodayIcon className={icon} />,
    },
  ];  

  return (  
    <SearchContextProvider>  
      <Page themeId="home">  
        <Content>  
          <Grid container justifyContent="center" spacing={6}>  
            <HomePageCompanyLogo  
              className={container}  
              logo={<LogoFull />}
            />
            <Grid container>
              <Grid item md={12}>
                <NewAnnouncementBanner />
              </Grid>
            </Grid>
            <Grid container item xs={12} justifyContent="center">  
              <HomePageSearchBar  
                InputProps={{  
                  classes: { root: classes.searchBarInput, notchedOutline: classes.searchBarOutline },  
                }}  
                placeholder="Search"  
              />  
            </Grid> 
            <Grid container item xs={12}>  
              <Grid item xs={12} md={6}>  
                <AnnouncementsCard max={3} />
              </Grid>  
              <Grid item xs={12} md={6}>  
                <HomePageToolkit tools={tools}/>  
              </Grid>  
            </Grid>
            <Grid item xs={12}>
              <HomePageStarredEntities />  
            </Grid>
          </Grid>
        </Content>  
      </Page>  
      </SearchContextProvider>  
  );
}; 